import React from "react";

const About = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column", // Adjust for smaller screens
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                backgroundColor: "#f9f9f9",
            }}
        >
            <h2
                style={{
                    color: "#004d40",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: "20px",
                }}
            >
                About Indien Buddy
            </h2>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row", // Horizontal layout for larger screens
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    flexWrap: "wrap", // Wraps for smaller screens
                    gap: "20px",
                    maxWidth: "95%",
                }}
            >
                {/* Card 1: Image */}
                <div
                    style={{
                        flex: "1 1 300px", // Flexible sizing with a minimum width
                        maxWidth: "400px",
                        backgroundColor: "#fff",
                        borderRadius: "15px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden", // Ensures clean edges
                        textAlign: "center",
                        padding: "10px",
                    }}
                >
                    <img
                        src={require("../images/gift_oldpeople.png")} // Replace with your image path
                        alt="About Indien Buddy"
                        style={{
                            maxWidth: "100%",
                            height: "auto", // Maintain aspect ratio
                            borderRadius: "10px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        }}
                    />
                </div>

                {/* Card 2: Text */}
                <div
                    style={{
                        flex: "1 1 300px", // Flexible sizing with a minimum width
                        maxWidth: "600px",
                        backgroundColor: "#fff",
                        borderRadius: "15px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        padding: "20px",
                        textAlign: "center",
                    }}
                >
                    <p
                        style={{
                            fontSize: "1.1rem",
                            lineHeight: "1.8",
                            color: "#444",
                            marginBottom: "10px",
                        }}
                    >
                        Indien Buddy is your trusted companion for bridging the distance
                        between you and your loved ones in India. Whether it’s sending
                        heartfelt gifts, planning memorable surprises, or supporting your
                        family with essentials, we are here to ensure every moment is
                        special.
                    </p>
                    <p
                        style={{
                            fontSize: "1.1rem",
                            lineHeight: "1.8",
                            color: "#444",
                        }}
                    >
                        Our support takes convenience to the next level, allowing you to
                        celebrate occasions and care for your loved ones with ease, no
                        matter where you are.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
